import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelInventario(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <h1>Panel Inventario</h1>
            </div>



        </Fragment>
    );
};


export default withRouter(PanelInventario)
